import { useQuery } from '@tanstack/react-query';
import { IGetFavoriteProfessionalsParams } from '../favoriteProfessionalsApi';
import { favoriteProfessionalsService } from '../favoriteProfessionalsService';
import { IFavoriteProfessional } from '../favoriteProfessionalsTypes';

type TUseFavoriteProfessionalsParams = IGetFavoriteProfessionalsParams & {
  enabled: boolean;
};

export function useFavoriteProfessionals(params: TUseFavoriteProfessionalsParams) {
  return useQuery<IFavoriteProfessional[]>({
    queryKey: ['favorite-professionals', params],
    queryFn: () => favoriteProfessionalsService.getFavoriteProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
}
